export default {
  __pagination: require("./pagination.gql").default,
  __page: require("./page.gql").default
};
